'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllEventScoresURL = exports.releaseCommentsFlagUrl = exports.getGroupFeeAssignedToEvent = exports.eventMedalRoundsAreLoading = exports.getEventMedalRoundsAssociatedToAdjs = exports.eventAdjudicatorsAreLoading = exports.areCommentsLoading = exports.getEventDressCheck = exports.getEventComment = exports.getEventScores = exports.resultsForPersonIsLoading = exports.getResultsByPerson = exports.getParticipantsOfAnEvent = exports.participantsOfAnEventAreLoading = exports.getEventPlacements = exports.getPlacedForPersonInEvent = exports.getPlacementForPersonInEvent = exports.getParticipatedEventsForScoring = exports.getEvents = exports.eventsWithStatus = exports.eventsWithStatusAreLoading = exports.eventsAreLoading = exports.getEvent = exports.eventsResultsPath = exports.participantsPath = exports.eventsPath = exports.eventPath = exports.feisPrefixUrl = exports.feisEventsPrefix = undefined;

var _immutable = require('immutable');

var feisEventsPrefix = exports.feisEventsPrefix = function feisEventsPrefix(feis_id) {
  return IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/events';
};

var feisPrefixUrl = exports.feisPrefixUrl = function feisPrefixUrl(feis_id) {
  return IFEIS_API_URI + '/api/feiseanna/' + feis_id;
};

var eventPath = exports.eventPath = function eventPath(event_id) {
  return ['events', 'one', event_id];
};

var eventsPath = exports.eventsPath = function eventsPath(feis_id) {
  return ['feiseanna', 'events', feis_id, 'all'];
};
var participantsPath = exports.participantsPath = function participantsPath(event_id) {
  return ['events', 'participants', event_id];
};

var eventsResultsPath = exports.eventsResultsPath = function eventsResultsPath(feis_id, person_id) {
  return ['events', 'persons', person_id, 'feiseanna', feis_id, 'results'];
};

var getEvent = exports.getEvent = function getEvent(state, event_id) {
  return state.getIn(eventPath(event_id)) || (0, _immutable.Map)();
};

var eventsAreLoading = exports.eventsAreLoading = function eventsAreLoading(state, feis_id) {
  return !state.getIn(['feiseanna', 'events', feis_id]) || state.getIn(['feiseanna', 'events', feis_id, 'loading']);
};

var eventsWithStatusAreLoading = exports.eventsWithStatusAreLoading = function eventsWithStatusAreLoading(state, feis_id, status) {
  return !state.getIn(['events', 'byStatus', status, feis_id]) || state.getIn(['events', 'byStatus', status, feis_id, 'loading']);
};

var eventsWithStatus = exports.eventsWithStatus = function eventsWithStatus(state, feis_id, status) {
  return state.getIn(['events', 'byStatus', status, feis_id]).map(function (eid) {
    return getEvent(state, eid);
  });
};

var getEvents = exports.getEvents = function getEvents(state, feis_id) {
  return state.getIn(eventsPath(feis_id));
};

var getParticipatedEventsForScoring = exports.getParticipatedEventsForScoring = function getParticipatedEventsForScoring(state, feis_id, pid) {
  return state.getIn(['events', 'persons', pid, 'feiseanna', feis_id, 'participated']) || (0, _immutable.List)();
};

var getPlacementForPersonInEvent = exports.getPlacementForPersonInEvent = function getPlacementForPersonInEvent(state, eid, pid) {
  return state.getIn(['events', 'persons', pid, eid, 'placements']);
};

var getPlacedForPersonInEvent = exports.getPlacedForPersonInEvent = function getPlacedForPersonInEvent(state, eid, pid) {
  return state.getIn(['events', 'persons', pid, eid, 'placed']);
};

var getEventPlacements = exports.getEventPlacements = function getEventPlacements(state, eid) {
  return state.getIn(['events', eid, 'placements']);
};

var participantsOfAnEventAreLoading = exports.participantsOfAnEventAreLoading = function participantsOfAnEventAreLoading(state, event_id) {
  return !state.getIn(participantsPath(event_id)) || state.getIn(['events', 'participants', event_id, 'loading']);
};

var getParticipantsOfAnEvent = exports.getParticipantsOfAnEvent = function getParticipantsOfAnEvent(state, event_id) {
  return state.getIn(participantsPath(event_id));
};

var getResultsByPerson = exports.getResultsByPerson = function getResultsByPerson(state, feis_id, person_id) {
  return state.getIn(eventsResultsPath(feis_id, person_id));
};

var resultsForPersonIsLoading = exports.resultsForPersonIsLoading = function resultsForPersonIsLoading(state, feis_id, person_id) {
  return state.getIn(eventsResultsPath(feis_id, person_id).concat(['loading']));
};

var getEventScores = exports.getEventScores = function getEventScores(state, eid, aid) {
  return state.getIn(['events', 'scores', eid, aid]) || (0, _immutable.List)();
};

var getEventComment = exports.getEventComment = function getEventComment(state, eid, aid, pid) {
  return state.getIn(['events', 'comments', eid, aid, pid]) || (0, _immutable.List)();
};

var getEventDressCheck = exports.getEventDressCheck = function getEventDressCheck(state, eid, aid, pid) {
  return state.getIn(['events', 'dresschecks', eid, aid, pid]) || (0, _immutable.List)();
};

var areCommentsLoading = exports.areCommentsLoading = function areCommentsLoading(state, eid, aid, pid) {
  return state.getIn(['events', 'comments', eid, aid, pid, 'loading']) || (0, _immutable.List)();
};

var eventAdjudicatorsAreLoading = exports.eventAdjudicatorsAreLoading = function eventAdjudicatorsAreLoading(state, eid) {
  return !state.getIn(['events', 'adjudicators', eid]) || state.getIn(['events', 'adjudicators', eid, 'loading']);
};

var getEventMedalRoundsAssociatedToAdjs = exports.getEventMedalRoundsAssociatedToAdjs = function getEventMedalRoundsAssociatedToAdjs(state, event_id) {
  return state.getIn(['events', 'rounds', event_id]) || (0, _immutable.List)();
};

var eventMedalRoundsAreLoading = exports.eventMedalRoundsAreLoading = function eventMedalRoundsAreLoading(state, event_id) {
  return state.getIn(['events', 'rounds', event_id, 'loading']);
};

var getGroupFeeAssignedToEvent = exports.getGroupFeeAssignedToEvent = function getGroupFeeAssignedToEvent(state, event_id) {
  return state.getIn(['events', 'groupFee', event_id]) || (0, _immutable.Map)();
};

var releaseCommentsFlagUrl = exports.releaseCommentsFlagUrl = function releaseCommentsFlagUrl(fid, eid, status) {
  return IFEIS_API_URI + '/api/feiseanna/' + fid + '/events/' + eid + '/releasecomments/' + status;
};

var getAllEventScoresURL = exports.getAllEventScoresURL = function getAllEventScoresURL(fid, eid) {
  return IFEIS_API_URI + '/api/feiseanna/' + fid + '/events/' + eid + '/scores';
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/paths.js
// module id = 4
// module chunks = 0